import { useCallback, useMemo } from "react";
import { useHistory } from "react-router";

import { LinearProgress } from "../../application/LinearProgress";
import { useUser } from "../../user/UserProvider";
import { CurrentCustomersTab } from "./CurrentCustomersTab";
import { useGardeningTasksByStatus } from "../../gardening-task/gardener-view/gardening-tasks-gardener-view.hook";
import { collapseGardeningTasksToTheMostRelevantTaskPerCustomer } from "../../gardening-task/gardening-task.utility";

export const IntegratedCurrentCustomersTab = () => {
    const gardener = useUser();

    const gardeningTasks = useGardeningTasksByStatus(gardener.id, "found gardener");
    
    const relevantGardeningTasks = useMemo(() => {
        if ( !gardeningTasks ) return undefined;

        const collapsedGardeningTasks = collapseGardeningTasksToTheMostRelevantTaskPerCustomer(gardeningTasks);

        return collapsedGardeningTasks.filter(x => x.status === "found gardener" && x.working.status !== "has finished working");
    }, [gardeningTasks]);

    const history = useHistory();
    const goToCustomer = useCallback((customerId: string) => {
        history.push(`/customers/current/${customerId}`);
    }, [history]);
    
    if ( relevantGardeningTasks === undefined ) return <LinearProgress />;

    return (
        <CurrentCustomersTab
            gardeningTasks={relevantGardeningTasks}
            goToCustomer={goToCustomer}
        />
    );
};
